import { ClarionButton } from '@clarion/ClarionButton';
import { ClarionCallout } from '@clarion/ClarionCallout';
import { signOut } from './UserState';

export default function LoadError() {
  return (
    <ClarionCallout
      intent="danger"
      title="Unable to load Recap"
      className="max-w-prose m-auto mt-12"
    >
      Check your internet connection and try again. If that doesn’t work, please log out and log
      back in.
      <div className="flex gap-2 flex-wrap my-2">
        <ClarionButton onClick={() => window.location.reload()}>Try again</ClarionButton>
        <ClarionButton onClick={signOut}>Log out</ClarionButton>
      </div>
    </ClarionCallout>
  );
}
